import { jsPDF } from "jspdf";

// Lightweight markdown -> plain text for PDF export
function stripMd(md) {
  return md
    .replace(/^#{1,6}\s*/gm, "")
    .replace(/\*\*(.*?)\*\*/g, "$1")
    .replace(/\*(.*?)\*/g, "$1")
    .replace(/`([^`]+)`/g, "$1")
    .replace(/^\s*[-*]\s+/gm, "• ")
    .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1");
}

export function exportToPDF(title, content, filename = "my-elite-document") {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const marginX = 48;
  const marginTop = 60;
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const maxWidth = pageWidth - marginX * 2;
  let y = marginTop;

  // header bar
  doc.setFillColor(11, 30, 63);
  doc.rect(0, 0, pageWidth, 40, "F");
  doc.setTextColor(245, 130, 31);
  doc.setFont("helvetica", "bolditalic");
  doc.setFontSize(14);
  doc.text("MY ELITE", marginX, 26);
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.text("by Thotis Media", pageWidth - marginX, 26, { align: "right" });

  // title
  doc.setTextColor(11, 30, 63);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  const titleLines = doc.splitTextToSize(title, maxWidth);
  doc.text(titleLines, marginX, y);
  y += titleLines.length * 22 + 8;

  // body
  doc.setTextColor(30, 30, 30);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  const text = stripMd(content);
  const lines = doc.splitTextToSize(text, maxWidth);
  lines.forEach((line) => {
    if (y > pageHeight - 50) { doc.addPage(); y = marginTop; }
    doc.text(line, marginX, y);
    y += 16;
  });

  doc.save(`${filename}.pdf`);
}
